import { Theme } from '@mui/material'

import useSharedStyles from '../../utils/shared.styles'

const useStyles = {
  divider: (theme: Theme) => ({
    ...useSharedStyles.fullWidthContainer,
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% + 48px)',
      marginLeft: '-24px',
      marginRight: '-24px',
    },
  }),
  preferencesSubheader: (theme: Theme) => ({
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
  }),
  dropdown: (theme: Theme) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: '12px',
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  }),
  cardSection: (theme: Theme) => ({
    marginTop: theme.spacing(1),
  }),
  preferencesCard: (theme: Theme) => ({
    borderRadius: '12px',
    boxShadow: 'none',
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(0, 2),
    color: theme.palette.text.primary,
  }),
  radioOption: (theme: Theme) => ({
    margin: 0,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: 0,
    marginRight: 0,
  }),
  regionalSection: {
    paddingTop: 1,
  },
}

export default useStyles
